import { useEffect, useState } from "react";
import { apiFetch } from "api/Api";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Link } from "react-router-dom";
import { FaPlus, FaEdit, FaTrash, FaFileAlt, FaFilter, FaCalendarAlt, FaChevronLeft, FaChevronRight, FaFolderOpen } from "react-icons/fa";
import "assets/theme/admin_list.css";

const LetterTemplateList = () => {
  const [templates, setTemplates] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [limit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState("");

  const loadCategories = async () => {
    try {
      const data = await apiFetch("super_admin/list_help_category");
      setCategories(data.categories || []);
    } catch (error) {
      alert(error.message);
    }
  };

  const loadTemplates = async () => {
    setLoading(true);
    try {
      const data = await apiFetch(
        `super_admin/list_letter_format?page=${page}&limit=${limit}&category_id=${selectedCategory}`
      );
      setTemplates(data.letter_formats || []);
      setTotalPages(data.pagination?.totalPages || 1);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTemplates();
  }, [page, selectedCategory]);

  useEffect(() => {
    loadCategories();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("तुम्हाला हा नमुना हटवायचा आहे का?")) return;

    try {
      await apiFetch(`super_admin/delete_letter_format/${id}`, {
        method: "DELETE",
      });
      loadTemplates();
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid py-3">
        {/* Header Card */}
        <div className="admin-header-card mb-4">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 position-relative" style={{ zIndex: 1 }}>
            <div className="d-flex align-items-center gap-3">
              <div className="admin-header-icon-box">
                <FaFileAlt />
              </div>
              <div>
                <h4 className="text-white fw-bold mb-1" style={{ fontSize: "1.3rem" }}>
                  पत्र नमुना व्यवस्थापन / Letter Templates
                </h4>
                <p className="text-white-50 mb-0" style={{ fontSize: "0.88rem" }}>
                  मदत अर्जासाठी अधिकृत पत्र नमुने व्यवस्थापित करा
                </p>
              </div>
            </div>

            <Link to="/letter_templates" className="btn btn-admin-add">
              <FaPlus /> <span>नवीन नमुना जोडा</span>
            </Link>
          </div>
        </div>

        {/* Filter Card */}
        <div className="admin-filter-card mb-4">
          <div className="row g-3 align-items-center">
            <div className="col-md-5 col-lg-4">
              <label className="form-label fw-semibold text-muted small mb-1">
                <FaFilter className="me-1 text-primary" /> श्रेणी नुसार फिल्टर:
              </label>
              <select
                className="form-select border-1 shadow-none"
                value={selectedCategory}
                onChange={(e) => {
                  setPage(1);
                  setSelectedCategory(e.target.value);
                }}
              >
                <option value="">सर्व श्रेणी (All Categories)</option>
                {categories.map((cat) => (
                  <option key={cat.category_id} value={cat.category_id}>
                    {cat.category_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Table Card */}
        <div className="admin-table-card">
          <div className="card-body p-0">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-warning" role="status"></div>
                <p className="text-muted mt-2 fw-semibold mb-0">माहिती लोड होत आहे...</p>
              </div>
            ) : templates.length === 0 ? (
              <div className="text-center py-5">
                <FaFolderOpen className="text-muted mb-3" style={{ fontSize: "2.5rem", opacity: 0.4 }} />
                <h6 className="text-muted fw-bold">नमुने उपलब्ध नाहीत</h6>
                <p className="text-muted small mb-0">निवडलेल्या श्रेणीमध्ये कोणतेही पत्र नमुने आढळले नाहीत.</p>
              </div>
            ) : (
              <>
                <div className="table-responsive">
                  <table className="table table-admin-custom align-middle">
                    <thead>
                      <tr>
                        <th style={{ width: "80px" }}>Sr. No.</th>
                        <th>शीर्षक व नमुना (Title & Content)</th>
                        <th>श्रेणी (Category)</th>
                        <th>अतिरिक्त फील्ड (Extra Fields)</th>
                        <th>दिनांक (Created)</th>
                        <th className="text-center" style={{ width: "120px" }}>क्रिया (Actions)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {templates.map((item, index) => (
                        <tr key={item.template_id}>
                          <td>
                            <span className="fw-semibold text-muted">
                              {((page - 1) * limit + index + 1).toString().padStart(2, "0")}
                            </span>
                          </td>
                          <td>
                            <div className="fw-bold text-dark mb-1">{item.template_title}</div>
                            <div className="small text-muted text-truncate" style={{ maxWidth: "320px" }}>
                              {item.template_content}
                            </div>
                          </td>
                          <td>
                            <span className="badge bg-primary bg-opacity-10 text-primary fw-semibold px-3 py-1 rounded-pill">
                              {item.category_name}
                            </span>
                          </td>
                          <td>
                            {Number(item.total_extra_fields) === 0 ? (
                              <span className="badge bg-secondary bg-opacity-10 text-secondary fw-semibold px-2 py-1 rounded-pill">
                                अतिरिक्त फील्ड नाही
                              </span>
                            ) : (
                              <span className="badge bg-success bg-opacity-10 text-success fw-semibold px-2 py-1 rounded-pill">
                                {item.total_extra_fields} अतिरिक्त फील्ड
                              </span>
                            )}
                          </td>
                          <td>
                            <small className="text-muted">
                              <FaCalendarAlt className="me-1" />
                              {new Date(item.created_at).toLocaleDateString("mr-IN")}
                            </small>
                          </td>
                          <td>
                            <div className="d-flex justify-content-center gap-2">
                              <Link
                                to={`/edit_letter_template/${item.template_id}`}
                                className="btn-action-icon edit"
                                title="संपादित करा"
                              >
                                <FaEdit />
                              </Link>
                              <button
                                className="btn-action-icon delete"
                                title="हटवा"
                                onClick={() => handleDelete(item.template_id)}
                              >
                                <FaTrash />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                <div className="admin-pagination-bar">
                  <div className="text-muted small">
                    पान <span className="fw-bold text-dark">{page}</span> पैकी <span className="fw-bold text-dark">{totalPages}</span>
                  </div>

                  <nav>
                    <ul className="pagination mb-0 gap-1">
                      <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                        <button className="page-link" onClick={() => setPage(page - 1)}>
                          <FaChevronLeft className="me-1" /> मागील
                        </button>
                      </li>

                      {[...Array(totalPages)].map((_, i) => (
                        <li key={i} className={`page-item ${page === i + 1 ? "active" : ""}`}>
                          <button className="page-link" onClick={() => setPage(i + 1)}>
                            {i + 1}
                          </button>
                        </li>
                      ))}

                      <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                        <button className="page-link" onClick={() => setPage(page + 1)}>
                          पुढील <FaChevronRight className="ms-1" />
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default LetterTemplateList;
